import AccountCircleIcon from "@material-ui/icons/AccountCircleRounded";
import React from "react";

const UserProfilePic = class UserProfilePic extends React.Component {
  render() {
    const style = {
      borderRadius: "50%",
      height: this.props.height,
      border: "0.1rem solid white"
    };

    if (this.props.photoURL) {
      
      if (this.props._style) {
        Object.assign(style, this.props._style);
      }

      const wrapperStyle = this.props.showScore ? { position: "relative" } : {};

      return (
        <div style={wrapperStyle}>
          <img
            alt="Profile"
            src={this.props.photoURL}
            onError={function(ev) {
              ev.target.style = 'display:none'
            }}
            style={style}
          />

          {this.props.showScore && this.props.score ? (
            <span
              className="score"
              style={{
                backgroundColor: "green",
                borderRadius: "50%",
                color: "white",
                padding: "0.2rem",
                fontSize: "0.8rem",
                border: "0.1rem solid white",
                position: "absolute",
                bottom: "0",
                left: "-5px"
              }}
            >
              {this.props.score}
            </span>
          ) : null}
        </div>
      );
    } else {
      Object.assign(style, {
        backgroundColor: "#999",
        position: "absolute",
        left: "24%",
        top: "11%",
        zIndex: "1000",
        color: "white",
        width: "49%",
        height: "49%"
      });

      return <AccountCircleIcon style={style} />;
    }
  }
};

export default UserProfilePic;
